export default __webpack_public_path__ + "static/media/07AW1APR66.9fe1f8e2.jpg";